
import { AnalyticsEvent, AnalyticsProperties } from './types';

export class AnalyticsUtils {
  static async trackError(
    trackFn: (event: AnalyticsEvent, properties?: AnalyticsProperties) => Promise<void>,
    error: Error, 
    context?: string
  ): Promise<void> {
    await trackFn('error_occurred', {
      error_message: error.message,
      error_name: error.name,
      context: context || 'unknown',
      stack_trace: error.stack?.slice(0, 1000), // Limit stack trace length
    });
  }

  static async trackApiError(
    trackFn: (event: AnalyticsEvent, properties?: AnalyticsProperties) => Promise<void>,
    endpoint: string, 
    status: number, 
    message: string
  ): Promise<void> {
    await trackFn('api_error', {
      endpoint,
      status_code: status,
      error_message: message,
    });
  }

  static async trackAuthError(
    trackFn: (event: AnalyticsEvent, properties?: AnalyticsProperties) => Promise<void>,
    operation: string, 
    error: string
  ): Promise<void> {
    await trackFn('auth_error', {
      auth_operation: operation,
      error_message: error,
    });
  }

  static enhanceProperties(properties: AnalyticsProperties = {}): AnalyticsProperties {
    return {
      ...properties,
      timestamp: Date.now(),
      url: window.location.href,
      pathname: window.location.pathname,
    };
  }

  static enhancePageProperties(pageName?: string, properties: AnalyticsProperties = {}): AnalyticsProperties {
    return {
      ...properties,
      $current_url: window.location.href,
      $pathname: window.location.pathname,
      page_name: pageName,
      timestamp: Date.now(),
    };
  }
}
